import * as React from 'react'
import { Alert, Box, Button, Card, CardContent, CardHeader, Container, TextField } from '@mui/material'
import { AuthContext } from 'contexts/authContext'
import { ErrorContext } from 'contexts/errorContext'

/**
 * Login component for user authentication.
 */
const Login = () => {
  const [formData, setFormData] = React.useState({ email: '', password: '' })
  const [isLoading, setIsLoading] = React.useState(false)
  const [alert, setAlert] = React.useState(null)
  const { dispatch } = React.useContext(AuthContext)
  const { showError } = React.useContext(ErrorContext)

  // Handling form data
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  // Form submission
  const handleSubmit = async (e) => {
    e.preventDefault()
    setAlert(null)
    setIsLoading(true)

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })

      const json = await response.json()

      if (response.ok) {
        dispatch({ type: 'LOGIN', payload: json })
      } else {
        setAlert(json.message)
      }
    } catch (error) {
      showError('Failed to login. Please try again or refresh the page.')
      console.error(error.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Container maxWidth="sm" sx={{ minHeight: '70vh', my: 6 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          component="img"
          src="/images/freshmtl-logo.svg"
          alt="FreshMTL"
          sx={{
            width: 100,
            height: 100,
          }}
        />
      </Box>
      <Card variant="outlined" sx={{ mt: 4 }}>
        <CardHeader title="Sign In" />
        <CardContent>
          <Box component="form" onSubmit={handleSubmit}>
            <TextField fullWidth variant="outlined" type="email" label="Email" name="email" value={formData.email} onChange={handleChange} />
            <TextField
              fullWidth
              variant="outlined"
              type="password"
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              sx={{ mt: 3 }}
            />
            <Button fullWidth variant="contained" size="large" sx={{ mt: 3 }} type="submit" disabled={isLoading}>
              Login
            </Button>
            {alert && (
              <Alert severity="error" sx={{ mt: 3, border: 1, borderColor: 'error.light' }}>
                {alert}
              </Alert>
            )}
          </Box>
        </CardContent>
      </Card>
    </Container>
  )
}

export default Login
